import type { NitroFetchRequest } from 'nitropack/types'
import type { AsyncData, UseFetchOptions } from 'nuxt/app'
import { useFetch, useRequestURL } from 'nuxt/app'

/**
 * Выполняет Nuxt-запрос с host исходного SSR-запроса.
 *
 * Второй generic описывает данные после `transform`, а не тип ошибки.
 *
 * @param request - Nitro route или функция, возвращающая route
 * @param options - параметры Nuxt `useFetch`
 * @returns состояние асинхронного запроса с преобразованными данными
 */
export function useNuxtApi<ResT, DataT = ResT>(
  request: NitroFetchRequest | (() => NitroFetchRequest),
  options?: UseFetchOptions<ResT, DataT>,
): AsyncData<DataT | undefined, Error | undefined> {
  return useFetch(request, {
    ...options,
    headers: {
      ...options?.headers,
      'x-request-host': useRequestURL().host,
    },
  }) as AsyncData<DataT | undefined, Error | undefined>
}
